/**
 * Annotations read from catalog entities.
 *
 * Namespaced under the company domain so upstream Backstage releases can never
 * collide with them. Change the domain to match your own.
 */
export const MLFLOW_MODEL_NAME_ANNOTATION = 'mlflow.company.com/model-name';
export const MLFLOW_EXPERIMENT_ID_ANNOTATION = 'mlflow.company.com/experiment-id';

/** Optional. Which metric the card highlights for this model. */
export const MLFLOW_PRIMARY_METRIC_ANNOTATION = 'mlflow.company.com/primary-metric';

/** Optional. Which alias is treated as the deployed version. */
export const MLFLOW_CHAMPION_ALIAS_ANNOTATION = 'mlflow.company.com/champion-alias';

export const DEFAULT_CHAMPION_ALIAS = 'champion';

/**
 * Optional. Name of the platform cluster (Resource kubernetes-cluster in the catalog) the
 * model belongs to: the backend resolves the cluster's MLflow from the Resource's annotations
 * below instead of the single mlflow.baseUrl of app-config.
 */
export const VIVA_CLUSTER_ANNOTATION = 'viva.company.com/cluster';
/** On the cluster Resource: domain of the cluster ingress. */
export const VIVA_CLUSTER_DOMAIN_ANNOTATION = 'viva.company.com/cluster-domain';
/**
 * On the cluster Resource: domain of the cluster whose MLflow this cluster uses — its own
 * domain, or another cluster's when it shares that MLflow. Empty or missing: the cluster's
 * own domain. MLflow API is https://mlflow-api.<domain> (same rule as the ml-model template).
 */
export const VIVA_MLFLOW_DOMAIN_ANNOTATION = 'viva.company.com/mlflow-domain';
